import { Component, OnInit } from '@angular/core';
import { FiltrosResolucionEntity, DatosBaseResolucionEntity, FiltrosResolucionBodyEntity } from 'src/app/services/servicio-resolucion1552.service';
import { ActivatedRoute } from '@angular/router';

import { ServicioResolucion1552Service, DatosAgrupadosResolucion1552, EntidadEmpresarial, Sedes } from '../../services/servicio-resolucion1552.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ImagesService } from '../../services/utils/images.service';

@Component({
  selector: 'app-reporte-resolucion1552',
  templateUrl: './reporte-resolucion1552.component.html',
  styleUrls: ['./reporte-resolucion1552.component.css']
})
export class ReporteResolucion1552Component implements OnInit {
  mostrarReporte = true;
  loading: boolean;
  dowloading: boolean;
  logo: string;
  user: string;
  nombreUser: string;
  filtrosSeleccionados: FiltrosResolucionEntity;
  detalle: FiltrosResolucionBodyEntity[] = [];

  enviados: number;
  atendidos: number;
  pendientes: number;

  fechaImpresion: Date;

  datosAgrupados: DatosAgrupadosResolucion1552[];

  public datosBaseResolucionEntity: DatosBaseResolucionEntity = {
    codigoBaseDatos: '',
    uncoSede: '',
    uncoLogin: 0,
    uncoPuntoAtencion: '',
    uncoProcedimiento: '',
    uncoEntidad: ''
  };

  entidadEmpresarialTest: EntidadEmpresarial = {

    unco: 0,
    nombreEntidad: '',
    nit: '',
    direccion: 0,
    telefono: '',
  };


  public objetoResolucion: FiltrosResolucionEntity = {
    codigoBaseDatos: '',
    fechaInicial: 0,
    fechaFinal: 0,
    sede: '',
    puntoAtencion: '',
    lineaProducto: '',
    procedimiento: '',
    empresa: ''
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private servicioImagenes: ImagesService,
    private servicioResolucion1552: ServicioResolucion1552Service) {

    this.activatedRoute.params.subscribe(params => {
      this.datosBaseResolucionEntity.codigoBaseDatos = params['codigoBaseDatos'];
      this.datosBaseResolucionEntity.uncoSede = params['uncoSede'];
      this.datosBaseResolucionEntity.uncoEntidad = params['uncoEntidad'];
      this.datosBaseResolucionEntity.uncoLogin = params['user'];
      this.filtrosSeleccionados = this.objetoResolucion;
      this.user = params['user'];
      this.nombreUser = params['user'];
    });
  }

  ngOnInit() {
    this.filtrosSeleccionados = this.objetoResolucion;
    this.getLogo(this.objetoResolucion.codigoBaseDatos);
    this.fechaImpresion = new Date();
    this.datosAgrupados = [];
  }

  public onFiltrosCompletados(obj: FiltrosResolucionEntity) {
    this.loading = true;
    this.filtrosSeleccionados = obj;
    this.fechaImpresion = new Date();
    this.getLogo(obj.codigoBaseDatos);
    this.getData();
  }

  public updateEntidad(entidad: EntidadEmpresarial) {
    this.entidadEmpresarialTest = entidad;
  }

  async getLogo(codigoBaseDatos: string) {
    try {
      this.logo = '';
      this.loading = true;
      const response = await this.servicioImagenes.getLogo(codigoBaseDatos);
      if (response != null) {
        response.subscribe((data: any) => {
          this.logo = data.source;
          this.loading = false;
        }, (err: HttpErrorResponse) => {
          this.logo = '';
          this.loading = false;
        });
      }
    } catch (e) {
      this.logo = '';
      this.loading = false;
    }
  }

  mostrarLoadingFiltros(loading: any) {
    this.loading = true;
  }

  async getData() {
    try {
      this.enviados = 0;
      this.atendidos = 0;
      this.pendientes = 0;
      const response = await this.servicioResolucion1552.getConsolidadoData(this.filtrosSeleccionados);
      if (response != null) {
        response.subscribe((data: FiltrosResolucionBodyEntity[]) => {
          this.detalle = data;
          if (data == null) {
            this.mostrarReporte = false;
            this.loading = false;
          }
           this.agruparData(data);
          // let t = data[0].fechaAsignacionCita;
          this.loading = false;
          // this.detalle.forEach((d: FiltrosResolucionBodyEntity) => {
          //   if (d.estadoSolicitud === 1) {
          //     this.pendientes++;
          //   } else if (d.estadoSolicitud === 2) {
          //     this.atendidos++;
          //   }
          //   this.enviados = this.pendientes + this.atendidos;
          // });
        }, (err: HttpErrorResponse) => {
          console.error(err);
          this.loading = false;
        });
      }
    } catch (e) {
      console.log(e);
      this.loading = false;
    }
  }

  agruparData(data: FiltrosResolucionBodyEntity[]) {
    if (data) {
      data.forEach((d: FiltrosResolucionBodyEntity) => {
        const existeEmpresa = this.datosAgrupados.find((e: DatosAgrupadosResolucion1552) => {
          return e.empresa === d.empresa;
        });

        if (existeEmpresa) {
          existeEmpresa.datos.push(d);
        } else {
          const agrupacionEmpresa: DatosAgrupadosResolucion1552 = {
            empresa: d.empresa,
            datos: [d]
          };
          this.datosAgrupados.push(agrupacionEmpresa);
        }
      });
    }

  }

}
